import styled from "styled-components"

export const Contanier = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(3px);
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
`
export const Card = styled.div`
  width: 25rem;
  height: fit-content;
  border-radius: 10px;
  background-color: white;
  -webkit-box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 2px 2px 40px rgba(0, 0, 0, 0.5);
  @media (max-width: 700px) {
    width: 20rem;
    padding: 5px;
  }
`
export const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 300;
  text-align: center;
  // margin-left: 21%;
  @media (max-width: 700px) {
    margin-left: 2%;

    font-size: 1.6rem;
  }
`
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 10%;
  margin-top: 8%;
  margin-bottom: 5%;
`

export const Forms = styled.div`
  display: flex;
  flex-direction: column;
  width: 30vh;
  height: fit-content;
  gap: 2.5rem;
  justify-content: left;
`

export const LabelTermos = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  font-size: 1.1em;
  gap: 10px;
  width: fit-content;
  margin-bottom: 2rem;
`

export const Buttons = styled.button`
  width: 10%;
  height: 70%;
  margin-left: 10%;
  cursor: pointer;
  border: none;
  background-color: transparent;
  margin-top: 6%;
  transition: 0.2s ease-in-out;
  &:hover {
    transform: translateY(-7px);
  }
`
